// extracted by mini-css-extract-plugin
export default {"switch_wrapper":"_MqJv","checkbox":"kR6vR","back":"dc7jt","upload_wrapper":"oB9qj","upload_text":"Nl6Lw","upload":"jaTQK"};